import { render } from "./ProfilePoliticianInfoItem.vue?vue&type=template&id=f92a6c18&scoped=true"
import script from "./ProfilePoliticianInfoItem.vue?vue&type=script&lang=js"
export * from "./ProfilePoliticianInfoItem.vue?vue&type=script&lang=js"

import "./ProfilePoliticianInfoItem.vue?vue&type=style&index=0&id=f92a6c18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f92a6c18"]])

export default __exports__